// removed by extract-text-webpack-plugin
module.exports = {"logoContainer":"_2BC7d","logo":"_2Xesy"};


//////////////////
// WEBPACK FOOTER
// ./components/icons/SofortIcon/SofortIcon.scss
// module id = 281
// module chunks = 0 1